import React from 'react';
import { Testimonial } from '../../../types/index';
import { StarIcon } from '../../../components/common/Icons';

interface TestimonialCardProps {
  testimonial: Testimonial;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({ testimonial }) => {
  return (
    <div className="border-top pt-3">
      <figure className="mb-0">
        <blockquote className="blockquote">
          <div className="d-flex mb-2">
            {[...Array(5)].map((_, i) => (
              <StarIcon
                key={i}
                className={`${i < testimonial.rating ? 'text-primary' : 'text-secondary opacity-25'}`}
                style={{ height: '1.25rem', width: '1.25rem' }}
              />
            ))}
          </div>
          <p className="fs-6" style={{ fontStyle: 'italic', color: '#6c757d' }}>"{testimonial.comment}"</p>
        </blockquote>
        <figcaption className="blockquote-footer text-end mb-0 fw-semibold">
          {testimonial.clientName}
        </figcaption>
      </figure>
    </div>
  );
};

export default TestimonialCard;
